// extracted by mini-css-extract-plugin
module.exports = {"form":"MealsItemForm_form__26n9J"};